module.exports = __webpack_public_path__ + "media/tags/mass-3-41d9fcc0.png";